module.exports = __webpack_public_path__ + "img/77307.4387ee5e.svg";